import PropTypes from "prop-types";
import React from "react";
import styles from "./DisclosureDetails.module.css";

export function DisclosureDetails({ title, description, onChange }) {
  return (
    <section className={styles.card}>
      <div className={styles.inner}>
        <div className={styles.headerWrap}>
          <h3 className={styles.title}>Disclosure Details</h3>
        </div>
        <div className={styles.divider} />

        <div className={styles.longRow}>
          <label className={styles.label} htmlFor="disclosure-details-title">
            Title<span className={styles.required}> *</span>
          </label>
          <input
            id="disclosure-details-title"
            name="disclosureTitle"
            type="text"
            className={styles.input}
            placeholder="N/A"
            value={title}
            onChange={(event) => onChange("title", event.target.value)}
          />
        </div>

        <div className={styles.longRow}>
          <label
            className={styles.label}
            htmlFor="disclosure-details-description"
          >
            Description
          </label>
          <input
            id="disclosure-details-description"
            name="disclosureDescription"
            type="text"
            className={styles.input}
            placeholder="N/A"
            value={description}
            onChange={(event) => onChange("description", event.target.value)}
          />
        </div>
      </div>
    </section>
  );
}

DisclosureDetails.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

DisclosureDetails.defaultProps = {
  title: "",
  description: "",
};

export default DisclosureDetails;
